// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetCompanysByIdParam,
    BaseResponseCompanyFoundResponse,
    PutCompanysByIdParam,
    PutCompanysByIdBody,
    BaseResponseVoid,
} from '../../types';

/**
 * 获取租户详情
 *
 * @export
 * @tags 租户接口
 * @link [GET] /companys/{id}
 * @param id
 */
export function getCompanysById(
    options: ApiOptions<GetCompanysByIdParam, never> & { segments: GetCompanysByIdParam }
): Promise<BaseResponseCompanyFoundResponse> {
    return request<never, GetCompanysByIdParam, never>('/companys/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysById',
    });
}

/**
 * 更新租户接口
 *
 * @export
 * @tags 租户接口
 * @link [PUT] /companys/{id}
 * @param id
 */
export function putCompanysById(
    data: PutCompanysByIdBody,
    options: ApiOptions<PutCompanysByIdParam, never> & { segments: PutCompanysByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutCompanysByIdBody, PutCompanysByIdParam, never>('/companys/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putCompanysById',
    });
}

export const meta = [
    { tags: ['租户接口'], path: '/companys/{id}', method: 'get' },
    { tags: ['租户接口'], path: '/companys/{id}', method: 'put' },
];
